import Link from 'next/link';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import type { GeneralConditionCard } from '@/graphql/common/types';
import { DownloadFileIcon } from '@/icons';
import { getLocaleFromClientCookie } from '@/utils/getLocaleFromClientCookie';
import { cn } from '@/utils/mergeClassName';

type GeneralConditionItemProps = {
  item: GeneralConditionCard;
  className?: string;
};

const formatDateRanges = (item: GeneralConditionCard, locale = 'pt-BR') => {
  const startDate = parseISO(String(item?.start));
  const endDate = parseISO(String(item?.end));

  const isValidRangeDate = isValid(startDate) && isValid(endDate);

  if (!isValidRangeDate) {
    return '';
  }

  return startDate.toLocaleDateString(locale) + ' a ' + endDate.toLocaleDateString(locale);
};

const formatDocumentName = (name: string) =>
  name.toUpperCase().replace('_', ' ').replace('NUMERO', 'NÚMERO');

export const GeneralConditionItem = ({ item, className }: GeneralConditionItemProps) => {
  const locale = getLocaleFromClientCookie();

  return (
    <li className={cn('bg-white text-base font-semibold', className)}>
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <span className="text-sm uppercase text-grey-600">
            {item.validGeneralCondition ? 'Vigente' : formatDateRanges(item, locale)}
          </span>
          <p className="text-base font-bold text-blue-200">{item.title}</p>
          <span className="text-sm font-regular uppercase text-grey-600">
            {formatDocumentName(item.typeDocument)}: {item.document}
          </span>
        </div>

        <div>
          {item.file && (
            <Link
              href={item.file.url}
              target="_blank"
              download={item.file.name}
              aria-label="Download do arquivo"
              prefetch={false}
            >
              <DownloadFileIcon className="size-8 p-1 text-blue-200" />
            </Link>
          )}
        </div>
      </div>
    </li>
  );
};
